import { Pays } from './pays';
import { Projet } from './projet';
import { Region } from './region';

export class Site {
  siteId: number | undefined;
  nom!: string;
  isActif!: boolean;
  regionId!: number;
  paysId!: number;
  region: Region | undefined;
  groupByNomRegion!: string;
  pays: Pays | undefined;
  nbUtilisateurs!: number;
  nbZones!: number;
  profilId?: number;
  projets!: Projet[];
  epsg!: string;
  epsgCoordinates!: string;
  coordX!: number;
  coordY!: number;
}
